import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { addHereAccount, getHereAccounts } from "../../Services/API/HereDotCom";
import LoadingBar from "../LoadingBar/LoadingBar";
import { StyledTextField } from "../TextField/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
  textField: {
    "& .Mui-error": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.error.main,
    },
  },
}));

export default function HereDotComModal({ openModal, setData, setShowSignifier, setShowError }) {
  const classes = useStyles();

  const [showInputError, setShowInputError] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [isProduction, setIsProduction] = useState(false);
  const [appId, setAppId] = useState("");
  const [appCode, setAppCode] = useState("");
  const [notes, setNotes] = useState("");
  const [addProcessing, setAddProcessing] = useState(false);

  const data = {
    Name: accountName,
    AppId: appId,
    AppCode: appCode,
    Notes: notes,
    IsProduction: isProduction,
  };

  const checkAllEntered = () => {
    if (accountName === "" || appId === "" || appCode === "") {
      return false;
    }
    return true;
  };

  const submitData = () => {
    if (checkAllEntered()) {
      setAddProcessing(true);
      addHereAccount(data).then(() => {
        getHereAccounts().then((res) => {
          setShowSignifier(true);
          if (res) {
            for (const i in res) {
              res[i].betaSize = res[i].clientHereDotComBetaAccounts.length;
              res[i].prodSize = res[i].clientHereDotComProductionAccounts.length;
              res[i].isProductionString = res[i].isProduction ? "Yes" : "No";
            }
            setData(res);
            openModal(false);
          } else {
            setShowError(true);
          }
          setAddProcessing(false);
        });
      });
    } else {
      setShowInputError(true);
    }
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={addProcessing} />
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <p>Add Here.com Account</p>
              </Grid>
              <Grid xs={12} sm={12} item>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Account Name"
                  label="Account Name"
                  variant="standard"
                  fullWidth
                  required
                  error={showInputError && accountName === ""}
                  className={classes.textField}
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                />
                {showInputError && accountName === "" && (
                  <FormHelperText className={classes.error}>Account Name Required</FormHelperText>
                )}
              </Grid>
              {showInputError && accountName === "" && (
                <FormHelperText className={classes.error}>Entry Required</FormHelperText>
              )}
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={isProduction}
                      onChange={(e) => setIsProduction(e.target.checked)}
                    />
                  }
                  label="Is Production?"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="App ID"
                  label="App ID"
                  variant="standard"
                  fullWidth
                  required
                  error={showInputError && appId === ""}
                  className={classes.textField}
                  value={appId}
                  onChange={(e) => setAppId(e.target.value)}
                />
                {showInputError && appId === "" && (
                  <FormHelperText className={classes.error}>App ID Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="App Code"
                  label="App Code"
                  error={showInputError && appCode === ""}
                  className={classes.textField}
                  value={appCode}
                  onChange={(e) => setAppCode(e.target.value)}
                  variant="standard"
                  fullWidth
                  required
                />
                {showInputError && appCode === "" && (
                  <FormHelperText className={classes.error}>App Code Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Notes"
                  label="Notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  variant="standard"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ color: "#82B288", marginTop: "20px" }}
                  type="submit"
                  variant="outlined"
                  disabled={addProcessing}
                  onClick={() => openModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginTop: "20px", marginLeft: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => submitData()}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
